import Vue from "vue";
import Router from "vue-router";
import findLast from "lodash/findLast";
import { notification } from "ant-design-vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import NotFound from "./views/404";
import Forbidden from "./views/403";
import unSubscription from "./views/unSubscription";
import Empty from "./views/empty";
import { check, isLogin } from "./utils/auth";
import login from "./views/login/login";
import loginRedirect from "./views/login/login_redirect";
import Cookies from "js-cookie";
import store from "./store";

var userDate = Cookies.get("userDate") ? true : false;
Vue.use(Router);

//解决重复点击菜单栏控制台报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

let toPath = "/";
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      meta: { authority: ["user", "admin"], requireAuth: true },
      component: () => import("./layouts/BasicLayout"),
      redirect: "/audience/userGroupList",
      children: [
        {
          path: "/empty",
          name: "empty",
          hideInMenu: true,
          component: Empty,
        },
        {
          path: "/noAuthority",
          name: "noAuthority",
          hideInMenu: true,
          component: () => import("./views/login/NoAuthority"),
        },
        {
          // path: "/bdslogin",
          path: "/unSubscription",
          name: "unSubscription",
          hideInMenu: true,
          component: unSubscription,
          // component: () =>
          //     import(/* webpackChunkName: "dashboard" */ "./views/User/SignIn")
        },
        {
          path: "/authority",
          name: "Authority",
          meta: { icon: "safety", title: "Settings" },
          component: { render: (h) => h("router-view") },
          children: [
            {
              path: "/authority/userManagement",
              name: "UserManagement",
              meta: { icon: "compass", title: "User Mgmt", requireAuth: true },
              component: () =>
                // SystemSetting
                import("./views/syssetup/UserMgt"),
            },
            {
              path: "/authority/roleManagement",
              name: "RoleManagement",
              meta: { icon: "key", title: "Role Mgmt", requireAuth: true },
              component: () => import("./views/syssetup/SysSettingMgt"),
            },
            {
              path: "/authority/accountDashboard",
              name: "AccountDashboard",
              meta: { icon: "key", title: "Account Dashboard", requireAuth: true },
              component: () => import("./views/syssetup/accountDashboard"),
            },

            {
              path: "/authority/tagManagement",
              name: "TagManagement",
              meta: { icon: "fire", title: "Tag", requireAuth: true },
              component: () => import("./views/datasetup/TagMgt"),
            },
          ],
        },
        {
          path: "/audience",
          name: "Audience",
          meta: { icon: "team", title: "人群管理", requireAuth: true },
          component: { render: (h) => h("router-view") },
          children: [
            {
              path: "/audience/userAnalysis",
              name: "UserAnalysis",
              meta: { icon: "solution", title: "人群看板", requireAuth: true },
              component: () => import("./views/crowd/UserGroupAnalysis"),
            },
            {
              path: "/audience/addUserGroup",
              name: "AddUserGroup",
              meta: {
                icon: "user-add",
                title: "人群探索",
                requireAuth: true,
              },
              component: () => import("./views/crowd/AddUserGroup"),
            },
            {
              path: "/audience/customGroup",
              name: "CustomGroup",
              meta: {
                icon: "user-add",
                title: "自定义人群",
                requireAuth: true,
              },
              component: () => import("./views/crowd/customGroup"),
            },
            {
              path: "/audience/uploadPackage",
              name: "UploadPackage",
              meta: {
                icon: "user-add",
                title: "上传人群包",
                requireAuth: true,
              },
              component: () => import("./views/crowd/UploadUserGroupPackage"),
            },
            {
              path: "/audience/userGroupList",
              name: "UserGroupList",
              meta: {
                icon: "usergroup-add",
                title: "人群列表",
                requireAuth: true,
              },
              component: () => import("./views/crowd/UserGroupList"),
            },
            {
              path: "/audience/userGroupDetail",
              name: "UserGroupDetail",
              meta: { icon: "user-add", title: "人群详情", requireAuth: true },
              hideInMenu: true,
              component: () => import("./views/crowd/UserGroupDetail"),
            },
          ],
        },
        {
          path: "/strategy",
          name: "Strategy",
          meta: {
            icon: "message",
            title: "AI Communication",
            requireAuth: true,
          },
          component: { render: (h) => h("router-view") },
          children: [
            {
              path: "/strategy/mgmt/mgmtStrategy",
              name: "MgmtStrategy",
              meta: { icon: "fire", title: "Deliv. Start.", requireAuth: true },
              component: () => import("./views/application/ai/StrategyPushMgt"),
            },{
              path: "/strategy/Dashboard",
              name: "Dashboard",
              meta: { icon: "fire", title: "Deliv. Start.", requireAuth: true },
              component: () => import("./views/application/ai/dashboard"),
            },
            {
              path: "/strategy/workflow",
              name: "Workflow",
              meta: {
                icon: "fire",
                title: "Workflow Config",
                requireAuth: true,
              },
              component: () =>
                // SystemSetting
                import("./views/application/ai/StrategyTaskConfig"),
            },
            {
              path: "/strategy/content/txtManagement",
              name: "TxtManagement",
              meta: { icon: "fire", title: "Content Mgmt", requireAuth: true },
              component: () => import("./views/material/textManagement"),
            },
            {
              path: "/strategy/UnSubscribe",
              name: "BlackAndWhiteList",
              meta: { icon: "key", title: "黑白名单管理", requireAuth: true },
              component: () =>
                import("./views/application/ai/blackAndWhiteList/index"),
            },
          ],
        },
      ],
    },
    {
      // path: "/bdslogin",
      path: "/login",
      name: "login",
      hideInMenu: true,
      component: login,
      // component: () =>
      //     import(/* webpackChunkName: "dashboard" */ "./views/User/SignIn")
    },
    {
      // path: "/bdslogin",
      path: "/login_redirect",
      name: "login_redirect",
      hideInMenu: true,
      component: loginRedirect,
      // component: () =>
      //     import(/* webpackChunkName: "dashboard" */ "./views/User/SignIn")
    },

    {
      path: "/403",
      name: "403",
      hideInMenu: true,
      component: Forbidden,
    },
    {
      path: "*",
      name: "404",
      hideInMenu: true,
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    NProgress.start();
  }

  if (
    to.path === "/login" ||
    to.path === "/login_redirect" ||
    to.path === "/unSubscription"
  ) {
    next();
  } else if (
    localStorage.getItem("userName") === "" ||
    localStorage.getItem("userName") === null
  ) {
    next("/login");
  } else {
    if (to.path === "/") {
      next(toPath);
    } else {
      next();
    }
store.dispatch('fetchButtonPermission');

  }

  NProgress.done();
});

router.afterEach(() => {
  NProgress.done();
});

async function dataListener(data) {
  toPath = data.path;
  await router.replace(data.path);
}

//在子应用中通过 window.__MICRO_APP_ENVIRONMENT__ 判断是否在微前端环境中。
if (window.__MICRO_APP_ENVIRONMENT__) {
  // 监听基座下发的数据变化
  window.microApp.addDataListener(dataListener, true);
}
export default router;
